import { ItemFilter } from 'services/useMyItems';

import { MyActivityHotDealsPage } from './MyActivityHotDealsPage';

export const MyActivitySellingPage = () => <MyActivityHotDealsPage selectedFilter={ItemFilter.SELLING} />;
